import axiosHandler from '../axiosInterceptors';
import { FETCH_TEAM_DATA, CREATE_TEAM_DATA, UPDATE_TEAM_DATA, DELETE_TEAM_DATA,FETCH_TEAM_GLOBAL_SEARCH_DATA, FETCH_TEAM_DROPDOWN_OPTION } from '../constants/urls';
import setAuthHeader from './AuthHeader';
// Call the setAuthHeader function to set the Authorization header
setAuthHeader();

export async function fetchTeamData(data) {
    try{
        const resp = await axiosHandler.get(FETCH_TEAM_DATA, data);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function createTeamData(data) {
    try{
        const resp = await axiosHandler.post(CREATE_TEAM_DATA, data);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function updateTeamData(data) {
    try{
        const resp = await axiosHandler.patch(UPDATE_TEAM_DATA, data);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function deleteTeamData(data) {
    try{
        const resp = await axiosHandler.delete(DELETE_TEAM_DATA + `?id=${data.id}`);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function fetchTeamGlobalSearchData(data) {
    try{
        const resp = await axiosHandler.post(FETCH_TEAM_GLOBAL_SEARCH_DATA, data);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function fetchTeamsDropdownOptionList() {
    try{
        const resp = await axiosHandler.get(FETCH_TEAM_DROPDOWN_OPTION);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}